module.exports = __webpack_public_path__ + "assets/img/payFail.ecf427d1.png";